
import Vue from 'vue';
export default Vue.extend({
  name: 'StepFour',
  props: {
    solar: {
      required: false,
      type: Boolean,
      default: () => false,
    },
    charger: {
      required: false,
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    navigateSolar() {
      // @ts-ignore
      this.$gtm.trackEvent({
        event: 'solar_followup',
        category: 'Flytteskjema',
        action: 'B2C',
        label: 'Kundeservice Flytteskjema',
      });
      window.open('https://bit.ly/3JXKRum', '_blank');
    },
    navigateCharger() {
      // @ts-ignore
      this.$gtm.trackEvent({
        event: 'evcharger_followup',
        category: 'Flytteskjema',
        action: 'B2C',
        label: 'Kundeservice Flytteskjema',
      });
      window.open('https://bit.ly/3tclgbb', '_blank');
    },
  },
});
